import React, { useState, useEffect,Fragment } from 'react';
import {
    makeStyles,
    withStyles,
    Typography,
    Slide as MUISlide,
    Dialog,
    IconButton,
    DialogContent,
    DialogActions,
    Button,
    DialogTitle,
    Divider,
    DialogContentText,
    Card,
    CardContent,
    FormHelperText,
    Collapse,
    Menu,
    MenuList,
    ClickAwayListener,
    Grow,
    Popper,
    InputAdornment,
    MenuItem,
    Grid
} from "@material-ui/core";
import { addExpenseDialogCss } from './ExpensesDialogCss';
import CloseIcon from '@material-ui/icons/Close';
import {
    TextField,
    Checkboxes,
    Radios,
    Select,
    DatePicker,
    TimePicker,
    Switches,
    Autocomplete
} from 'mui-rff';
import { Form, Field } from 'react-final-form';
import { connect } from "react-redux";
import DateFnsUtils from '@date-io/date-fns';
import { addVendorExpense,addExpenseV1,editExpenseV1,  getVehicleListV2,
} from '../../../store/actions/tripActionCreator';
import S3Uploader from '../s3Uploader/s3Uploader';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import DriverNameSelect from '../DriverDialogs/DriverNameSelect';
import { ExpenseTypeReceiptIcon,AddPersonIcon } from '../../../components/icons';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import * as logger from '../../../logger';
import { getTripDateFilterValues,isEmpty, numberWithCommas, replaceCommas, checkNumberOnly } from '../../../utils/utils';
import { updateVehicle3, singleTruck, PandL, Expenses, DriverExpenseType, AddExpenseTypeDriver, UpdateExpenseDetails, DeletePhotoAttachments } from '../../../store/actions/vehicleActionCreator';
import NotesIcon from '@material-ui/icons/Notes';
import AmountInput from '../Inputs/AmountInput';
import { trackDwebEvent } from '../../analytics';
import EventOutlinedIcon from '@material-ui/icons/EventOutlined';
import { defaultPageNo, defaultPageSize, defaultDebounceMs } from '../../../paginationVariables';
import { debounce } from 'lodash';
import { Waypoint } from "react-waypoint";
import AddShop from '../../pages/Shops/AddShop';
import { shopListForSelection } from '../../../store/actions/userActionCreators';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import AddNewExpense from '../../pages/Expenses/AddNewExpense';
import { getAllVehicleExpense,processVehicleExpenses } from '../../../store/actions/expensesActionCreators';
import AddVehicle from '../../pages/Vehicles/AddVehicle';
import { TruckIcon } from '../../../components/icons';
import AddAlertIcon from '@material-ui/icons/AddAlert';
import { sendSucces } from '../../../utils/utils';
import moment from 'moment';
const AddTruckExpenseDialog = ({ 
    open, 
    onClose, 
    vehicle,
    expenses,
    user,
    dispatchUpdateExpenseDetails, 
    dispatchPhotoAttachmentDelete, 
    onConfirm, 
    dispatchAddExpenseTypeDriver, 
    dispatchUpdateVehicleNew, 
    dispatchGetSingleTruck, 
    dispatchGetPandL, 
    dispatchGetTripExpenses, 
    dispatchGetAllVehicleExpense, 
    dispatchAddExpenseTypeMaintenance, 
    dispacthAddExpenses, 
    edit, 
    expenseData,
    dispatchAddExpenseV1,
    dispatchEditExpenseV1,
    dispatchGetShopList,
     expenseId,
     dispatchGetVehicleListAction,
     trip
    }) => {

    let submit;
    let vehicleVal =expenseId&& expenseData && expenseData.vehicleInfo && expenseData.vehicleInfo.vehicleId ? expenseData.vehicleInfo : null;
    const [dialogOpen, setDialogOpen] = useState(open);
    const [formError, setFormError] = React.useState(false);
    const [addDriverDialog, setAddDriverDialog] = useState(false);
    const [paidByDriverValue, setPaidByDriverValue] = useState(false);
    const [addExpensePhoto, setAddExpensePhoto] = useState(expenseData && expenseData.attachments ? expenseData.attachments : []);
    const [vehicleAllExpenseTypes, setVehicleAllExpenseTypes] = useState([]);
    const [expenseTypeValue, setExpenseTypeValue] = useState({ expenseName: expenseData && expenseData.expenseName ? expenseData.expenseName : "" });
    const [expenseTypeOpen, setExpenseTypeOpen] = useState(false);
    const [driverNameValue, setDriverNameValue] = useState("");
    const [amountValue, setAmountValue] = useState("");
    const [reminderDuration, setReminderDuration] = useState("");
    const [reminderDurationUnit, setReminderDurationUnit] = useState("");
    const [reminderConfigValue, setReminderConfigValue] = useState([]);
    const [remindMeValue, setRemindMeValue] = useState(true);
    const [expenseDate,setExpenseDate] = useState(expenseData && expenseData.expenseDate ? new Date(expenseData.expenseDate * 1000) : new Date())

    const [expensePaymentMethod, setExpensePaymentMethod] = React.useState('cash');
    const [expenseTransactionId, setExpenseTransactionId] = React.useState('');
    const [shopsListData, setShopsListData] = React.useState(null);
    const [shops, setShops] = React.useState([]);
    const [expenseShop, setExpenseShop] = React.useState(null);
    const [shopInputValue, setShopInputValue] = React.useState('');
    const [currentPageNo,setCurrentPageNo]  = useState(1);
    const [currentPageSize,setCurrentPageSize]  = useState(10);
    const [addShopOpen, toggleAddShopOpen] = React.useState(false);
    const [shopDialogValue, setShopDialogValue] = React.useState({
        name: ''
    });
    const [addExpenseOpen, toggleAddExpenseOpen] = React.useState(false);
    const [expenseDialogValue, setExpenseDialogValue] = React.useState({
        name: ''
    });
    //vehicle
  const [vehicleValue, setVehicleValue] = React.useState({
    ...vehicleVal,
    id:vehicleVal&&vehicleVal.vehicleId?vehicleVal.vehicleId:null
  });
  const [vehicleInputValue, setVehicleInputValue] = React.useState("");
  const [vehicleListOpen, setvehicleListOpen] = React.useState(false);
  const [vehicleListOptions, setVehicleListOptions] = React.useState([]);
  const vehicleLoading = vehicleListOpen && trip && trip.createTripVehicles && trip.createTripVehicles.trucks && trip.createTripVehicles.trucks.length === 0;
  const [addVehicleOpen, toggleAddVehicleOpen] = React.useState(false);
  const [vehicleDialogValue, setVehicleDialogValue] = React.useState({
    vehicleNumber: ''
  });
  const [currentPageNoVehicle,setCurrentPageNoVehicle]  = useState(1);
  const [currentPageSizeVehicle,setCurrentPageSizeVehicle]  = useState(10);
  const handleAddVehicleClose = () => {
    setVehicleDialogValue({
      vehicleNumber: '',
    });
    toggleAddVehicleOpen(false);
  };
  const handleVehicleSave = (status, response) => {
    toggleAddVehicleOpen(false);
    let defaultRequest = {
        pageSize:defaultPageSize,
        pageNo:defaultPageNo
    }
    setVehicleValue(response && response.id ? response : null);
      if (response && response.driverId && response.driverName) {
        /*setDriverValue(response && response.driverId ? {
          id: response.driverId,
          name: response.driverName,
          fleetOwnerId: response.fleetOwnerId,
          contactNumber: response.driverNumber
        } : null);*/
    }
  }
  const fetchVehicles = (search,pagination)=>{
    let req = {
      pageSize:defaultPageSize,
      pageNo:defaultPageNo,
    }
    if(pagination){
      req.pageNo = currentPageNoVehicle+1;
      req.merge = true;
    }
    if(search){
      req.search=search;
    }
    dispatchGetVehicleListAction(req, () => { }, () => { })
  }
  const onSearchBlurVehicles = debounce(query => {
    setCurrentPageNoVehicle(defaultPageNo)
    fetchVehicles(query,false)
  }, user && user.configs && user.configs.dwebSearchBebounceMs?parseInt(user.configs.dwebSearchBebounceMs):defaultDebounceMs);
    const handleAddExpenseClose = () => {
        setExpenseDialogValue({
        name: '',
        });
        toggleAddExpenseOpen(false);
    };
    const handleExpenseSave = (status, response) => {
        toggleAddExpenseOpen(false);
        setExpenseTypeValue(response)
        dispatchGetAllVehicleExpense(
            (data) => {
                if (data.status && data.status.code == 200) {
                    setVehicleAllExpenseTypes(data.response);
                }
            },
            () => {
            }
        );
    }
    const handleAddShopClose = () => {
        setShopDialogValue({
        name: '',
        });
        toggleAddShopOpen(false);
    };
    const handleShopSave = (status, response) => {
        toggleAddShopOpen(false);
        fetchShops()
        setExpenseShop(response && response.id ? response : null);
    }
    const onSearchBlur = debounce(query => {
        setCurrentPageNo(defaultPageNo)
        fetchShops(query,false)
      }, user && user.configs && user.configs.dwebSearchBebounceMs?parseInt(user.configs.dwebSearchBebounceMs):defaultDebounceMs);
      const fetchShops = (search,pagination)=>{
          let req = {
            pageSize:defaultPageSize,
            pageNo:defaultPageNo,
          }
          if(pagination){
            req.pageNo = currentPageNo+1
          }
          if(search){
            req.search=search;
          }
          dispatchGetShopList(req,(res)=>{
            if(res && res.status && res.status.code && res.status.code == 200 && res.response){
              setShopsListData(res.response)
              if(pagination){
                setShops([...shops,...res.response.shops])
              }else{
                setShops(res.response.shops)
              }
            }
          },()=>{

          })
    }
    useEffect(() => {
        if (expenseTypeValue && expenseTypeValue.expenseName) {
          let name = (expenseTypeValue.expenseName.replace(/\'/g, "")).trim();

          let splitted = name.split(" ");

          let value = "";

          splitted.forEach((splittedString) => {
              value += splittedString.charAt(0).toUpperCase() + splittedString.slice(1) + " ";
          });

          name = value.trim();
          let allExpenseTypes = expenses && expenses.allVehicleExpenseTypes ? expenses.allVehicleExpenseTypes : []
          let index = allExpenseTypes && allExpenseTypes.length > 0 && allExpenseTypes.findIndex(x => x.expenseName === name);

          let reminder = allExpenseTypes && allExpenseTypes.length > 0 && allExpenseTypes[index] && allExpenseTypes[index].reminderConfig ? allExpenseTypes[index].reminderConfig : "";
          setReminderConfigValue(reminder);
        }
        if (expenseData && expenseData.id) {
          if(expenseData.vehicleInfo&& expenseData.vehicleInfo.vehicleId){
              dispatchGetSingleTruck(expenseData.vehicleInfo.vehicleId,(data)=>{
                if (data.status && data.status.code == 200) {
                  setVehicleValue(data.response)
                  if(expenseData.paymentMethod){
                    setExpensePaymentMethod(expenseData.paymentMethod)
                  }
                  if(expenseData.paymentMethod && expenseData.paymentMethod == 'credit' && expenseData.shopId && expenseData.shopName){
                      setExpenseShop({
                          id:expenseData.shopId,
                          name:expenseData.shopName
                      })
                  }
                  if(expenseData.paymentMethod && expenseData.paymentMethod == 'online' && expenseData.paymentData){
                      setExpenseTransactionId(expenseData.paymentData)
                  }
                }
              })
          }
        }
    }, [open,expenseTypeValue, expenseData]);
    React.useEffect(() => {
        let defaultRequest = {
          pageSize:defaultPageSize,
          pageNo:defaultPageNo
        }
        if (vehicleListOpen) {
          dispatchGetVehicleListAction(defaultRequest, () => { }, () => { })
        }
      }, [vehicleListOpen]);
    useEffect(()=>{
        let active = true;
        if(shopInputValue ===''){
          return undefined;
        }
        return()=>{
          active = false
        }
    },[shopInputValue])
    useEffect(()=>{
      if(expensePaymentMethod && expensePaymentMethod == 'credit'){
      }
      if(expensePaymentMethod && expensePaymentMethod == 'paid_by_driver'){
        handlePaidByDriver()
      }
    },[expensePaymentMethod])

    let singleTruck = vehicle.singleTruck;
    let truckBook = vehicle.truckBooks;

    const filter = createFilterOptions();

    const classes = addExpenseDialogCss();


    useEffect(() => {

        dispatchGetAllVehicleExpense(
            (data) => {
                logger.log("Add Truck Expense", "Get vehicle expense type successfull");
                if (data.status && data.status.code == 200) {
                }
            },
            () => {
                logger.log("Add Truck Expense", "Get Vehicle Expense Type Failed");
            }
        );

    }, [open]);
    const initialValues = {
        paidByDriver: paidByDriverValue,
        amount: amountValue ? amountValue : expenseData && expenseData.amount ? numberWithCommas(expenseData.amount) : "",
        expenseType: expenseTypeValue && expenseTypeValue.expenseName ? expenseTypeValue : "",
        expenseDate:expenseDate ? expenseDate : new Date(),
        notes: expenseData && expenseData.description ? expenseData.description : "",
        paymentMethod:expensePaymentMethod,
        transactionId:expenseTransactionId,
        shop:expenseShop,
        vehicle:vehicleValue,
        kmReading:expenseData&&expenseData.kmReading?expenseData.kmReading:'',
    }

    const handleAddExpensePhoto = (file) => {
        var newPhoto = [...addExpensePhoto];
        newPhoto.push({ s3Link: file });
        setAddExpensePhoto(newPhoto);
    }

    const handleDeleteExpensePhoto = (index, attachId) => {
        var newPhoto = [...addExpensePhoto];
        newPhoto.splice(index, 1);
        setAddExpensePhoto(newPhoto);

        if (attachId) {
            dispatchPhotoAttachmentDelete(
                expenseId,
                attachId,
                () => {
                    logger.log("Add Fuel Expense Dialog", "Attachment deleted successfully");
                },
                () => {
                    logger.log("Add Fuel Expense Dialog", "Attachment delete failed");
                },
            )
        }
    }

    const handlePaidByDriver = (value) => {

        setPaidByDriverValue(!paidByDriverValue);

        if (vehicleValue && vehicleValue.id && !vehicleValue.driverId) {
            setAddDriverDialog(true);
        }
    }

    const handleAddDriverDialogClose = () => {
        setAddDriverDialog(false);
        setExpensePaymentMethod('cash')
    }

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
    }

    const handleAddDriverSubmit = (driverIdValue) => {

        let vehicleIdValue = vehicleValue&&vehicleValue.id?vehicleValue.id:'';
        var data = {
            driverId: driverIdValue
        }
        dispatchUpdateVehicleNew(
            vehicleIdValue,
            data,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    setVehicleValue(data.response)
                    setAddDriverDialog(false);
                    setExpensePaymentMethod('paid_by_driver')
                }
            },
            () => {
                logger.log("Add Driver Dialog", "Update Vehicle failed");
            }
        );
    }

    const validate = values => {
        const errors = {}
        if(values){
            if(errors.noValues){
              delete errors['noValues'];
            }
            if (!values.expenseType) {
                errors.expenseType = "Please select expense type."
            }
            if (!values.vehicle) {
                errors.vehicle = "Please select a Truck"
            }
            if (!values.amount || !checkNumberOnly(replaceCommas(values.amount))) {
                errors.amount = "Please enter valid amount."
            }
            if (!values.expenseDate) {
                errors.expenseDate = "Please select expense date"
            }
            if(!values.paymentMethod){
                errors.paymentMethod = 'Please Select a Payment Mode';
            }
            if(values && values.paymentMethod && values.paymentMethod =='credit' && !values.shop){
                errors.shop = 'Please Select a shop';
            }
        }else{
            errors.noValues = "novalues"
        }

        return errors
    }

    const onSubmit = values => {

        const fleetOwnerIdValue = user && user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : "";
        let splitted = ''
        if(values && values.expenseType && values.expenseType.expenseName){
          splitted = (values.expenseType.expenseName.replace(/\'/g, "")).split(" ");
        }else{
          splitted = values && values.expenseType ? (values.expenseType.replace(/\'/g, "")).split(" ") : [];
        }
        let {
            paymentMethod,
            shop,
            kmReading,
            transactionId
           } = values;

        let value = "";

        splitted.forEach((splittedString) => {
            value += splittedString.charAt(0).toUpperCase() + splittedString.slice(1) + " ";
        });

        var expenseValue = value.trim();
        let allExpenseTypes = expenses && expenses.allVehicleExpenseTypes ? expenses.allVehicleExpenseTypes : []
        let index = allExpenseTypes.findIndex(x => x.expenseName === expenseValue);
        let expenseTypeSelectedValue = allExpenseTypes && allExpenseTypes[index] && allExpenseTypes[index].expenseType ? allExpenseTypes[index].expenseType : "";
        let expenseParentTypeValue = allExpenseTypes && allExpenseTypes[index] && allExpenseTypes[index].expenseParentType ? allExpenseTypes[index].expenseParentType : "";
        var expenseData = {
            vehicleId:vehicleValue&&vehicleValue&&vehicleValue.id ? vehicleValue.id : "",
            fleetOwnerId: fleetOwnerIdValue,
            amount: replaceCommas(values.amount),
            expenseDate: Math.round((values.expenseDate.setHours(0, 0, 0, 0) / 1000)),
            attachments: addExpensePhoto,
            expenseType: expenseTypeSelectedValue,
            expenseParentType: expenseParentTypeValue,
            description: values.notes,
            paymentMethod:paymentMethod,
            paidByDriver: values.paidByDriver,
        }
        if (paymentMethod && paymentMethod == 'online' && transactionId) {
            expenseData['paymentData'] = transactionId;
        }else{
          expenseData['paymentData'] = null;
        }
        if (paymentMethod && paymentMethod == 'paid_by_driver') {
            expenseData['paidByDriver'] = true;
        }
        if (paymentMethod && paymentMethod == 'credit' && shop && shop.id) {
            expenseData['shopId'] = shop.id;
        } else {
          expenseData['shopId'] = null;
        }
        if(kmReading)
          expenseData['kmReading']=kmReading
        else
          expenseData['kmReading']=null
        if (edit) {
            dispatchEditExpenseV1(
                expenseId,
                expenseData,
                (data) => {
                    if (data.status && data.status.code == 200) {
                        sendSucces("Truck Expense Updated Successfully")
                        setDialogOpen(false);
                        onConfirm(moment(values.expenseDate).format('MMM-YYYY'));
                    }
                },
                () => {
                    logger.log("Add Fuel Expense Dialog Dweb", "Update expense failed");
                }
            );
        } else {
            dispatchAddExpenseV1(expenseData,
                (data) => {
                    if (data.status && data.status.code == 200) {
                        sendSucces("Truck Expense added Successfully")
                        setDialogOpen(false);
                        onConfirm(moment(values.expenseDate).format('MMM-YYYY'));
                        trackDwebEvent("Dweb SVP Other Expenses Expense Created Successfully", {
                            vehicle_id: data && data.response && data.response.vehicleId ? data.response.vehicleId : "",
                            vehicle_number: truckBook.vehicleNumber ? truckBook.vehicleNumber : "",
                            total_other_expense: truckBook.totalCost ? truckBook.totalCost : "",
                            expense_amount: data && data.response && data.response.amount ? data.response.amount : "",
                            expense_id: data && data.response && data.response.id ? data.response.id : "",
                        });
                    }
                },
                () => {
                    logger.log("Single Vehicle Add Maintenance Dialog", "Add expense failed");
                }
            );
        }
    }

    const handleChangeDriver= ()=>{
      if (vehicleValue && vehicleValue.id && vehicleValue.driverId && vehicleValue.driverName) {
        setDriverNameValue({ name: vehicleValue.driverName, id:  vehicleValue.driverId });
        setAddDriverDialog(true);
      }
    }

    const getFormFields = (values) => {
        return [
            {
                size: 12,
                visible: expenses && expenses.allVehicleExpenseTypes && expenses.allVehicleExpenseTypes.length > 0 ? true : false,
                field: (
                    <>
                        <div className={classes.titleV1} >Expense Type*</div>
                        <Autocomplete
                            classes={{
                                listbox: classes.listBoxAutoCompelete,
                                option: classes.listBoxOption,
                                input: classes.textTransformCaptialize
                            }}
                            id="select-truck-expense-type"
                            //label="Expense Type"
                            name="expenseType"
                            size="small"
                            required={true}
                            placeholder="Expense Type"
                            groupBy={(option) => option.mapper}
                            filterSelectedOptions
                            value={expenseTypeValue}
                            onChange={(event, newValue) => {
                                let newTypeValue = newValue ? newValue.toString() : "";
                                if (typeof newValue === 'string') {
                                    // timeout to avoid instant validation of the dialog's form.
                                    setTimeout(() => {
                                      setExpenseTypeValue('');
                                      toggleAddExpenseOpen(true);
                                      setExpenseDialogValue({
                                        name: newValue ? newValue.replace(/\"/g, "") : "",
                                      });
                                    });
                                } else if (newValue && newValue.inputValue) {
                                    setExpenseTypeValue(null);
                                    toggleAddExpenseOpen(true);
                                    setExpenseDialogValue({
                                      name: newValue.inputValue ? newValue.inputValue.replace(/\"/g, "") : "",
                                    });
                                } else if (newValue && newValue.inputValue === '') {
                                    setExpenseTypeValue('');
                                    toggleAddExpenseOpen(true);
                                    setExpenseDialogValue({
                                      name: "",
                                    });
                                }else {
                                    setExpenseTypeValue(newValue);
                                }
                            }}
                            getOptionSelected={(option, value) => option.expenseName === value.expenseName}
                            autoHighlight
                            options={expenses && expenses.allVehicleExpenseTypes ? expenses.allVehicleExpenseTypes : []}
                            clearOnBlur
                            getOptionValue={option => option.expenseName}
                            getOptionLabel={(option) => {
                                // e.g value selected with enter, right from the input
                                let value = option.expenseName ? option.expenseName.replace(/\"/g, "") : "";
                                if (typeof option === 'string') {
                                    // setExpenseTypeValue(option);
                                    return value;
                                }
                                if (option) {
                                    // setExpenseTypeValue(option);
                                    return value;
                                }
                                // setExpenseTypeValue(option);

                                return value;
                            }}
                            disableCloseOnSelect={false}
                            filterOptions={(options, params) => {

                                const filtered = filter(options, params);

                                filtered.unshift({
                                    inputValue: params.inputValue,
                                    expenseName: params.inputValue && params.inputValue.length>0?`"${params.inputValue}"`:'',
                                    add:true
                                });
   
                                return filtered;

                            }}
                            renderOption={(option, params) => {
                                if (option && option.add) {
                                    return (
                                        <>
                                            <div className={classes.newExpenseTypeV1}>
                                                <div className={classes.newExpenseTypeV2}>
                                                    <ExpenseTypeReceiptIcon className={classes.fontSize18} />
                                                    <div className={classes.divV6}>{params.inputValue && params.inputValue.length>0?'Add Custom Expense called':'Add Custom Expense'}</div>
                                                    <div className={classes.capitalize}>{option.expenseName}</div>
                                                </div>
                                                <ChevronRightIcon className={classes.cherveRightIcon} />
                                            </div>
                                        </>
                                    );
                                } else {
                                    return (
                                        <div className={classes.divExpenseName}>
                                            {option.expenseName}
                                        </div>
                                    );
                                }
                            }}
                            textFieldProps={
                              {
                                placeholder: "Expense Type",
                                variant: "outlined",
                                margin: 'none',
                                className:classes.divMargin
                              }
                            }
                            multiple={false}
                        />
                    </>
                ),
            },
            {
              size:12,
              visible:expenseId?false:true,
              field: (
                <>
                      <div className={classes.titleV1}>Truck Registration No.*</div>
                      <Autocomplete
                        classes={{
                          listbox: classes.listBoxAutoCompelete,
                          option: classes.listBoxOption
                        }
                        }
                        id="select-vehicle-list"
                        open={vehicleListOpen}
                        onOpen={() => {
                          setvehicleListOpen(true)
                        }}
                        onClose={() => {
                         setvehicleListOpen(false)
      
                        }}
                        onChange={(event, newValue) => {
                          if (typeof newValue === 'string') {
                            // timeout to avoid instant validation of the dialog's form.
                            setVehicleValue(null);
                            toggleAddVehicleOpen(true);
                            setVehicleDialogValue({
                              vehicleNumber: newValue.toUpperCase()
                            });
                          } else if (newValue && newValue.inputValue) {
                            setVehicleValue(null);
                            toggleAddVehicleOpen(true);
                            setVehicleDialogValue({
                              vehicleNumber: newValue.inputValue.toUpperCase()
                            });
                          } else if (newValue && newValue.inputValue === '') {
                            setVehicleValue(null);
                            toggleAddVehicleOpen(true);
                            setVehicleDialogValue({
                              vehicleNumber: ''
                            });
                          } else {
                            setVehicleValue(newValue && newValue.id ? newValue : null);
                          }
                        }}
                        name="vehicle"
                        size="small"
                        /*getOptionSelected={(option, value) =>{
                          return option.id === value.id && value.status != 'ONTRIP'
                        }}*/
                        required={true}
                        value={vehicleValue}
                        //groupBy={(option) => option.truckMapper}
                        autoHighlight
                        //freeSolo
                        options={trip && trip.createTripVehicles && trip.createTripVehicles.trucks ?trip.createTripVehicles.trucks.filter((v)=>v&&v.ownershipType&&v.ownershipType=='SELF') : []}
                        selectOnFocus
                        clearOnBlur
                        handleHomeEndKeys
                        filterSelectedOptions
                        getOptionValue={option => option.id}
                        getOptionSelected={(option, value) => option.id === value.id}
                        getOptionLabel={(option) => {
                          // e.g value selected with enter, right from the input
                          if (typeof option === 'string') {
                            return '';
                          }
                          if (option.inputValue || !option.id) {
                            return '';
                          }
                          return option.vehicleNumber
                        }}
                        //disableCloseOnSelect={false}
                        filterOptions={(options, params) => {
                          //const filtered = filter(options, params);
                          let filtered =[]
                          options.forEach((item,index)=>{
                            filtered.push({
                              ...item,
                              index:index
                            })
                          });
                          filtered.unshift({
                            inputValue: params.inputValue,
                            vehicleNumber: params.inputValue && params.inputValue.length > 1 ? `Add Details for '${params.inputValue.toUpperCase()}'` : `Add New Vehicle`,
                          });
                          return filtered;
                        }}
                        renderOption={(option, { selected, inputValue }) => {
      
                          const vehicleNumberValue = option && option.vehicleNumber ? option.vehicleNumber.split(/'/) : option.vehicleNumber;
      
                          if (vehicleNumberValue && vehicleNumberValue.length > 0 && !vehicleNumberValue.includes("Add New Vehicle")) {
                            vehicleNumberValue.pop();
                          }
      
                          if (option && option.id) {
                            let list = trip && trip.createTripVehicles && trip.createTripVehicles.trucks?trip.createTripVehicles.trucks.filter((v)=>v&&v.ownershipType&&v.ownershipType=='SELF'):[]
                            if (option.index == list.length-1) {
                              return(<Fragment>
                                      <Waypoint
                                        onEnter={() => {
                                          if(trip && trip.createTripVehicles && trip.createTripVehicles.maxPage && trip.createTripVehicles.maxPage != currentPageNoVehicle){
                                            setCurrentPageNoVehicle(currentPageNoVehicle+1)
                                            fetchVehicles(option.inputValue,true)
                                          }
                                        }}
                                      />
                                       <div className={classes.vehicleListItem}>
                                          <div className={classes.divVehicleListing}>
                                            <span>{option.vehicleNumberPrefix}
                                              <span className={classes.vehicleNumberSuffix}>{option.vehicleNumberSuffix}</span>
                                              {option.lastLocation && <>
                                                <FiberManualRecordIcon className={classes.titleBullet}></FiberManualRecordIcon>
                                                {option.lastLocation}
                                              </>}
                                            </span>
                                          </div>
                                          <div className={classes.vehicleListItemFlex}>
                                            <div className={classes.ownershipType}>
                                              <span className={option.ownershipType && option.ownershipType == 'HIRED' ? classes.hired : classes.own}>{option.ownershipType && option.ownershipType == 'HIRED' ? 'Market' : 'Own'}</span>
                                            </div>
                                            <div className={classes.vehicleStatus}><span>{option.status}</span><FiberManualRecordIcon className={option.status && option.status == 'ONTRIP' ? classes.onTripBullet : classes.avilableBullet}></FiberManualRecordIcon></div>
                                          </div>
                                        </div>
                                    </Fragment>);
                            }else{
                                return (
                                  <div className={classes.vehicleListItem}>
                                    <div className={classes.divVehicleListing}>
                                      <span>{option.vehicleNumberPrefix}
                                        <span className={classes.vehicleNumberSuffix}>{option.vehicleNumberSuffix}</span>
                                        {option.lastLocation && <>
                                          <FiberManualRecordIcon className={classes.titleBullet}></FiberManualRecordIcon>
                                          {option.lastLocation}
                                        </>}
                                      </span>
                                    </div>
                                    <div className={classes.vehicleListItemFlex}>
                                      <div className={classes.ownershipType}>
                                        <span className={option.ownershipType && option.ownershipType == 'HIRED' ? classes.hired : classes.own}>{option.ownershipType && option.ownershipType == 'HIRED' ? 'Market' : 'Own'}</span>
                                      </div>
                                      <div className={classes.vehicleStatus}><span>{option.status}</span><FiberManualRecordIcon className={option.status && option.status == 'ONTRIP' ? classes.onTripBullet : classes.avilableBullet}></FiberManualRecordIcon></div>
                                    </div>
                                  </div>
                                );
                            }
                          } else {
                            return (
                              <div className={classes.partyAddListItem}>
                                <TruckIcon className={classes.truckIcon} />
                                {vehicleNumberValue && vehicleNumberValue.map((value, index) => (
                                  <span style={{ color: index == 0 ? '#0033cc' : 'black', marginLeft: 10 }}>{value}</span>
                                ))
                                }
                                <ChevronRightIcon className={classes.cherveRightIcon} />
                              </div>
                            );
                          }
      
                        }}
                        //inputValue={vehicleInputValue}
                        onInputChange={(e, val) => {
                          setVehicleInputValue(val.toUpperCase())
                          onSearchBlurVehicles(val,false)
                        }}
                        textFieldProps={
                          {
                            placeholder: "Eg: KA 02 Q 1234",
                            variant: "outlined",
                            margin: 'none',
                            className:classes.divMargin
                          }
                        }
                        multiple={false}
                      />
                </>
              ),
            },
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.marginV2}>
                            <div className={classes.title}>Amount Paid*</div>
                            <AmountInput
                                placeholder="Amount Paid"
                                name="amount"
                                variant="outlined"
                                size="small"
                                onChange={(e) => setAmountValue(e.target.value)}
                                fieldProps={{
                                    // parse: value => value && numberWithCommas(value)
                                }}
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">&#x20b9;</InputAdornment>
                                }}
                                className={classes.marginV1}
                            />
                        </div>
                    </>
                ),
            },
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.marginV2}>
                            <div className={classes.title}>Expense Date*</div>
                            <DatePicker
                                disableFuture
                                name="expenseDate"
                                margin="none"
                                variant="inline"
                                fullWidth={true}
                                onChange={(date) => { setExpenseDate(date) }}
                                inputVariant="outlined"
                                size="small"
                                format="dd-MM-yyyy"
                                placeholder="Select Date"
                                dateFunsUtils={DateFnsUtils}
                                className={classes.marginV1}
                                InputProps={{ endAdornment: <InputAdornment position="end"><EventOutlinedIcon className={classes.eventIcon}></EventOutlinedIcon></InputAdornment> }}
                            />
                        </div>
                    </>
                ),
            },
            {
                size: 12,
                visible: values.expenseType,
                field: (
                    <>
                        {reminderConfigValue && reminderConfigValue.length > 0 &&
                            <div className={classes.divV7}>
                                <div className={classes.divV8}>
                                    <AddAlertIcon />
                                    <div>Remind me</div>
                                    {remindMeValue &&
                                        <>
                                            <div className={classes.divV9}>after</div>
                                            {reminderConfigValue && reminderConfigValue.length > 0 &&
                                                <Select
                                                    name="reminderValue"
                                                    variant="outlined"
                                                    //label={''}
                                                    notched
                                                    labelWidth={0}
                                                    placeholder={''}
                                                    formControlProps={{ margin: 'none', size: "small", fullWidth: false, labelWidth: 0 }}
                                                    className={classes.selectV1}
                                                >
                                                    {reminderConfigValue && reminderConfigValue.length > 0 && reminderConfigValue.map((type, index) => {
                                                        return (<MenuItem key={index} value={type.display}>{type.display}</MenuItem>);
                                                    })}
                                                </Select>
                                            }
                                        </>
                                    }
                                </div>
                                <Switches
                                    size='small'
                                    margin='normal'
                                    formControlProps={{
                                        className: classes.switchControl
                                    }}
                                    onChange={(e, value) => { setRemindMeValue(value) }}
                                    className={classes.switch}
                                    name="remindMe"
                                    data={{ label: '', value: true }} label="" />
                            </div>
                        }
                    </>
                )
            },
            {
                size: 12,
                visible: true,
                field: (
                    <div className={classes.marginV2}>
                        <div className={classes.title}>Current KM Reading</div>
                        <TextField
                            placeholder="Current KM Reading"
                            name="kmReading"
                            variant="outlined"
                            size="small"
                            className={classes.marginV1}
                            InputProps={{
                                endAdornment: <InputAdornment position="end">KMs</InputAdornment>
                            }}
                        />
                    </div>
                ),
            },
            {
              size: 12,
              visible: true,
              inline: false,
              field: (
                <>
                  {/* <div className={classes.divTripV2}>Billing Information</div> */}
                  <div className={classes.marginV2}>
                  <div className={classes.title}>Payment Mode*</div>
                  <Radios
                    //label="Payment Mode"
                    name="paymentMethod"
                    required={true}
                    formControlProps={{
                      margin: 'none',
                      className: classes.billingTypeRadio,
                      fullWidth: true
                    }}
                    formControlLabelProps={{
                      className: classes.billingTypeLabel
                    }}
                    className={classes.mtV2}
                    onChange={(e) => {setExpensePaymentMethod(e.target.value)}}
                    formLabelProps={{}}
                    radioGroupProps={{ row: true }}
                    data={vehicleValue&&vehicleValue.id?[
                      { value: 'cash', label: 'Cash' },
                      { value: 'credit', label: 'Credit' },
                      { value: 'paid_by_driver', label: 'Paid By Driver' },
                      { value: 'online', label: 'Online' }
                    ]:[
                      { value: 'cash', label: 'Cash' },
                      { value: 'credit', label: 'Credit' },
                      { value: 'online', label: 'Online' }
                    ]}
                  />
                  </div>
                </>
              ),
            },
            {
              size: 12,
              visible:values && values.paymentMethod && values.paymentMethod=='credit'?true:false,
              field: (<Autocomplete
                required={true}
                id="search-shop-input"
                onOpen={()=>{
                  fetchShops()
                }}
                //getOptionLabel={(option) => (typeof option === 'string' ? option : option.name)}
                options={shops}
                autoComplete
                name="shop"
                //includeInputInList
                filterSelectedOptions
                size="small"
                //disableClearable
                value={expenseShop}
                getOptionSelected={(option, value) => option.id === value.id}
                onChange={(event, newValue) => {
                  if (typeof newValue === 'string') {
                    // timeout to avoid instant validation of the dialog's form.
                    setTimeout(() => {
                      setExpenseShop('');
                      toggleAddShopOpen(true);
                      setShopDialogValue({
                        name: newValue ? newValue : "",
                      });
                    });
                  } else if (newValue && newValue.inputValue) {
                    setExpenseShop(null);
                    toggleAddShopOpen(true);
                    setShopDialogValue({
                      name: newValue.inputValue ? newValue.inputValue : "",
                    });
                  } else if (newValue && newValue.inputValue === '') {
                    setExpenseShop('');
                    toggleAddShopOpen(true);
                    setShopDialogValue({
                      name: "",
                    });
                  } else {
                    setExpenseShop(newValue && newValue.id ? newValue : null);
                  }
                }}
                filterOptions={(options, params) => {
                  let filtered =[]
                  options.forEach((item,index)=>{
                    filtered.push({
                      ...item,
                      index:index
                    })
                  });
                    filtered.unshift({
                        inputValue: params.inputValue,
                        name: params.inputValue && params.inputValue.length > 1 ? `Add "${params.inputValue}" as Shop` : `Add New Shop`,
                        add: true
                    });
                  return filtered;
                }}
                clearOnBlur
                multiple={false}
                getOptionValue={option => option}
                getOptionLabel={(option) => {
                  // e.g value selected with enter, right from the input
                  if (typeof option === 'string') {
                    return '';
                  }
                  if (option.inputValue || !option.id) {
                    return '';
                  }
                  return option && option.name ? option.name : ''
                }}
                onInputChange={(event, newInputValue) => {
                  setShopInputValue(newInputValue);
                  onSearchBlur(newInputValue,false)
                }}
                classes={
                    {
                      option:classes.shopOption
                    }
                  }
                textFieldProps={
                  {
                    label: "Shop",
                    placeholder: "Search and select shop",
                    variant: "outlined",
                    margin: 'normal',
                  }
                }
                renderOption={(option, { selected, inputValue }) => {
                  let matchesName, matchesNumber;
                  let partsName, partsNumber;
                  matchesName = match(option.name, inputValue);
                  partsName = parse(option.name, matchesName);
                  matchesNumber = match(option.contactNumber, inputValue);
                  partsNumber = parse(option.contactNumber, matchesNumber);

                  if (option && option.id) {
                    if (option.index == shops.length-1) {
                      return (
                        <Fragment>
                          <Waypoint
                            onEnter={() => {
                              if(!shopInputValue && shopsListData && shopsListData.maxPage && shopsListData.maxPage != currentPageNo){
                                setCurrentPageNo(currentPageNo+1)
                                fetchShops(option.inputValue,true)
                              }
                            }}
                          />
                         <div className={classes.shopListItem}>
                            {partsName.map((part, index) => {
                              return (<span key={index} style={{ fontWeight: part.highlight ? 300 : 'normal', color: part.highlight ? '#0033cc' : '#0b1323' }}>
                                {part.text}
                              </span>
                              )
                            })}
                            {option.contactNumber && <>
                              <FiberManualRecordIcon className={classes.titleBullet}></FiberManualRecordIcon>
                              {partsNumber.map((part, index) => {
                                return (<span key={index} style={{ fontWeight: part.highlight ? 300 : 'normal', color: part.highlight ? '#0033cc' : '#0b1323' }}>
                                  {part.text ? (part.text).replace(/(\d{5})(\d{5})/, "$1-$2") : ""}
                                </span>
                                )
                              })}
                            </>}
                          </div>
                        </Fragment>
                      );
                    } else {
                      return (
                        <div className={classes.shopListItem}>
                        {partsName.map((part, index) => {
                          return (<span key={index} style={{ fontWeight: part.highlight ? 300 : 'normal', color: part.highlight ? '#0033cc' : '#0b1323' }}>
                            {part.text}
                          </span>
                          )
                        })}
                        {option.contactNumber && <>
                          <FiberManualRecordIcon className={classes.titleBullet}></FiberManualRecordIcon>
                          {partsNumber.map((part, index) => {
                            return (<span key={index} style={{ fontWeight: part.highlight ? 300 : 'normal', color: part.highlight ? '#0033cc' : '#0b1323' }}>
                              {part.text ? (part.text).replace(/(\d{5})(\d{5})/, "$1-$2") : ""}
                            </span>
                            )
                          })}
                        </>}
                      </div>
                      );
                    }
                  } else {
                    return (
                      <div className={classes.shopListItem1}>
                        <AddPersonIcon className={classes.addPersonIcon} />
                        {partsName.map((part, index) => {
                          return (<span key={index} style={{ color: index == 0 ? '#0033cc' : 'black' }}>
                            {part.text}
                          </span>
                          )
                        })}
                        <ChevronRightIcon className={classes.cherveRightIcon} />
                      </div>
                    );
                  }

                }}
                />)
            },
            {
              size: 12,
              visible: values && values.paymentMethod && values.paymentMethod=='online'?true:false,
              field: (
                <TextField
                  label={'Transaction ID'}
                  placeholder="Transaction ID"
                  name="transactionId"
                  variant="outlined"
                  size="small"
                  margin="normal"
                  onChange={(e) => { setExpenseTransactionId(e.target.value) }}
                />
              ),
            },
            {
              size: 12,
              visible: values && values.paymentMethod && values.paymentMethod=='paid_by_driver'?true:false,
              field: (
                <>
                <TextField
                  label={'Driver'}
                  placeholder="Driver"
                  name="selectedDriver"
                  variant="outlined"
                  size="small"
                  disabled
                  value={vehicleValue && vehicleValue.driverId && vehicleValue.driverName ? vehicleValue.driverName : ''}
                  margin="normal"
                />
                {!expenseId && vehicleValue && vehicleValue.driverId && vehicleValue.driverName && <Button variant="contained" className={classes.changeDriverButton} onClick={() => handleChangeDriver()} >
                      Change Driver
                </Button>}
                </>
              ),
            },
            {
                size: 12,
                visible: true,
                field: (
                    <div className={classes.marginV2}>
                        <div className={classes.title}>Notes</div>
                        <TextField
                            placeholder="Notes"
                            name="notes"
                            variant="outlined"
                            size="small"
                            margin="normal"
                            multiline={true}
                            rows={3}
                            rowsMax={3}
                            className={classes.textNote}
                            InputProps={{
                                startAdornment: <InputAdornment position="start" className={classes.inputAdornmentV1}> <NotesIcon /></InputAdornment>
                            }}
                        />
                    </div>
                ),
            },
            {
                size: 12,
                visible: true,
                field: (
                    <div className={classes.marginV2}>
                        <Grid
                            container
                            spacing={1}
                            direction="row"
                            justify="flex-start"
                            alignItems="center"
                        >
                            {addExpensePhoto && addExpensePhoto.length > 0 &&
                                <Grid item>
                                    <div className="S3Uploader-image-margin">
                                        {addExpensePhoto && addExpensePhoto.map((expenseImage, index) => (
                                            <div className="S3Uploader-image-div" key={index}>
                                                {expenseImage.s3Link && <img className="S3Uploader-imagesrc" src={expenseImage.s3Link} alt="fileUpload" />}
                                                <img className="S3Uploader-imageclose" src={require("../../../assets/close-icon.svg")} onClick={() => { handleDeleteExpensePhoto(index, expenseImage.id) }}></img>
                                            </div>
                                        ))}
                                    </div>
                            </Grid>}
                            <Grid item>
                                <S3Uploader toggle={true} directoryName={"dweb-images/Vehicle/AddTruckExpense"} handleFile={handleAddExpensePhoto} />
                            </Grid>
                        </Grid>
                    </div>

                ),
            },
            {
                size: 12,
                visible:false, //handleDisplayPaidByDriver(values.expenseType),
                field: (
                    <div className={classes.divV4}>
                        <div className={classes.divV5}>Paid by {singleTruck && singleTruck.driverId && singleTruck.driverName ? singleTruck.driverName : 'Driver'}</div>
                        <Switches
                            size='small'
                            margin='normal'
                            formControlProps={{
                                className: classes.switchControl
                            }}
                            onChange={() => { handlePaidByDriver() }}
                            className={classes.switch}
                            name="paidByDriver"
                            data={{ label: '', value: true }} label="" />
                    </div>
                ),
            },
        ]
    }

    return (
        <>
            <Dialog fullWidth={true}
                onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="add-driver-dialog-title" open={dialogOpen} classes={{ paper: classes.paper2, paperWidthSm: classes.paperWidth }}>
                <DialogTitle className={classes.dialogTitleV1}>
                    {edit &&
                        <div className={classes.divV1}>Edit Truck Expense</div>
                    }
                    {!edit &&
                        <div className={classes.divV1}>Add Truck Expense</div>
                    }
                    <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <Form
                        onSubmit={onSubmit}
                        validateOnBlur={true}
                        //keepDirtyOnReinitialize
                        initialValues={initialValues}
                        validate={validate}
                        id="myForm"
                        render={({ handleSubmit, form, submitting, pristine, values }) => {
                            submit = handleSubmit;
                            setFormError(isEmpty(validate(values)));
                            return (
                                <form  onSubmit={handleSubmit} noValidate id="myForm">
                                    <Grid container alignItems="flex-start">
                                        {getFormFields(values).map((item, idx) => item.visible ? (
                                            <Grid item xs={item.size} key={idx}>
                                                {item.field}
                                            </Grid>
                                        ) : null)}
                                    </Grid>
                                </form>
                            )
                        }}
                    />
                </DialogContent>
                <Divider className={classes.marginV3} />
                <DialogActions className={classes.da1}>
                    <Button variant="contained" className={classes.cancelButton} onClick={() => handleClose()} >
                        Close
                    </Button>
                    <Button
                    className={!formError ? classes.disableCta : classes.saveCta}
                    disabled={!formError}
                    type="submit" variant="contained"
                        // onClick={() => {
                        //     document.getElementById('myForm')
                        //         .dispatchEvent(new Event('submit', { cancelable: true }))
                        // }}
                        onClick={event => {
                            submit(event)
                        }}
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
            {addDriverDialog && <DriverNameSelect onOpen={addDriverDialog} onClose={handleAddDriverDialogClose} fromSingleTruck={true} onConfirm={handleAddDriverSubmit} driverDetail={driverNameValue} />}
            {addShopOpen && <AddShop open={addShopOpen} defaultName={shopDialogValue.name} defaultNumber={shopDialogValue.number} onClose={handleAddShopClose} onSave={handleShopSave} />}
            {addExpenseOpen && <AddNewExpense open={addExpenseOpen} defaultName={expenseDialogValue.name} onClose={handleAddExpenseClose} onSave={handleExpenseSave} />}
            {addVehicleOpen && <AddVehicle open={addVehicleOpen} defaultVechicleNumber={vehicleDialogValue.vehicleNumber} onClose={handleAddVehicleClose} onSave={handleVehicleSave} />}
        </>
    )

}

const mapStateToProps = (state) => ({ vehicle: state.vehicle, user: state.user,expenses:state.expenses,trip:state.trip });
const mapDispatchToProps = (dispatch) => ({
    dispatchUpdateVehicleNew: (vehicleId, data, onSuccess, onFailure) => {
        dispatch(
            updateVehicle3(vehicleId, data, onSuccess, onFailure))
    },
    dispatchPhotoAttachmentDelete: (expenseId, attachId, onSuccess, onFailure) => dispatch(DeletePhotoAttachments(expenseId, attachId, onSuccess, onFailure)),
    dispatchUpdateExpenseDetails: (expenseId, data, onSuccess, onFailure) => dispatch(UpdateExpenseDetails(expenseId, data, onSuccess, onFailure)),
    dispacthAddExpenses: (data, onSuccess, onFailure) => dispatch(addVendorExpense(data, onSuccess, onFailure)),
    dispatchAddExpenseTypeDriver: (data, onSuccess, onFailure) => dispatch(AddExpenseTypeDriver(data, onSuccess, onFailure)),
    dispatchGetAllVehicleExpense: (onSuccess, onFailure) => dispatch(getAllVehicleExpense(onSuccess, onFailure)),
    dispatchGetSingleTruck: (truckId, onSuccess, onFailure) => dispatch(singleTruck(truckId, onSuccess, onFailure)),
    dispatchGetPandL: (data, defaultDateFilterValue, onSuccess, onFailure) => dispatch(PandL(data, defaultDateFilterValue, onSuccess, onFailure)),
    dispatchGetTripExpenses: (data, defaultTripBookFilterValue, onSuccess, onFailure) => dispatch(Expenses(data, defaultTripBookFilterValue, onSuccess, onFailure)),
    dispatchAddExpenseV1: (request, onSuccess, onFailure) =>
    dispatch(addExpenseV1(request, onSuccess, onFailure)),
    dispatchGetShopList: (data,onSuccess, onError) => {
        dispatch(shopListForSelection(data,onSuccess, onError))
    },
    dispatchEditExpenseV1: (expenseId, request, onSuccess, onFailure) =>
    dispatch(editExpenseV1(expenseId, request, onSuccess, onFailure)),
    dispatchGetVehicleListAction: (data, onSuccess, onFailure) => dispatch(getVehicleListV2(data, onSuccess, onFailure)),
});
export default connect(mapStateToProps, mapDispatchToProps)(AddTruckExpenseDialog);
